import ServiceLayout from "../components/ServiceLayout";

export default function DataAnalytics(){
  return(
    <ServiceLayout
      title="Data Analytics"
      subtitle="Turn data into business decisions."
      gradient="linear-gradient(135deg,#11998e,#38ef7d)"
      features={[
        "Dashboards",
        "Data Visualization",
        "Predictive Models",
        "Reports",
        "Machine Learning",
        "Insights Automation"
      ]}
    />
  );
}
